import React from 'react';
import moment from 'moment';
import {
  WidgetCustomFormFieldsRenderer,
  WidgetDynamicFormFieldsToFilterMapper,
  WidgetDynamicFieldsGetter,
} from '@erecruit/modules';
import {
  Flex,
  FormItem,
  RadioButtonGroup,
  RadioButton,
  Text,
} from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';

const ShiftWidgetFormExtension = Intl.injectIntl(
  ({
    intl,
    initialValue,
  }: Intl.InjectedIntlProps & { initialValue: number }) => (
    <FormItem
      id="rangeSelection"
      label={intl.formatMessage({
        id: messageIds.vms.widgets.table.shifts.range.title,
      })}
      options={{ initialValue: initialValue }}
    >
      <RadioButtonGroup>
        <Flex gutter={5} gutterDirection="horizontal" align="center">
          <RadioButton value={0}>
            <Text>
              <Intl.FormattedMessage
                id={messageIds.vms.widgets.table.shifts.range.today}
              />
            </Text>
          </RadioButton>
          <RadioButton value={1}>
            <Text>
              <Intl.FormattedMessage
                id={messageIds.vms.widgets.table.shifts.range.next7Days}
              />
            </Text>
          </RadioButton>
        </Flex>
      </RadioButtonGroup>
    </FormItem>
  ),
);

export const customRenderer: WidgetCustomFormFieldsRenderer = (
  widgetType: string,
  dynamicFilterArgs?: Record<string, unknown>,
) => {
  if (widgetType !== 'Shifts') {
    return null;
  }

  const initialValue =
    dynamicFilterArgs !== undefined
      ? Number(dynamicFilterArgs['rangeSelection']) || 0
      : 0;

  return <ShiftWidgetFormExtension initialValue={initialValue} />;
};

export const dynamicFieldsGetter: WidgetDynamicFieldsGetter = (
  widgetType,
  values,
) => {
  if (widgetType === 'Shifts') {
    return {
      rangeSelection: values['rangeSelection'],
    };
  }

  return {};
};

const Today = 0;
export const fieldsToFilterMapper: WidgetDynamicFormFieldsToFilterMapper = (
  widgetType,
  dynamicFormFieldValues,
) => {
  if (widgetType === 'Shifts') {
    const selection = dynamicFormFieldValues['rangeSelection'];
    const filterData: Date[] = [];
    if (selection === Today) {
      filterData.push(moment().toDate());
    } else {
      filterData.push(
        ...Array.from(Array(7).keys()).map(day =>
          moment()
            .add('days', day)
            .toDate(),
        ),
      );
    }
    return { startDates: filterData };
  }

  return {};
};
